<div *ngIf="errorMessage" class="error-banner">
  {{ errorMessage }}
</div>
